export default __webpack_public_path__ + "static/media/notFound.1ac0bb9e.jpg";